





























































































































































































































































import _ from "lodash";
import { Prop, Component, Vue } from "vue-property-decorator";
import { Company, Office, CompanyType } from "@/api/company-api";
import SwitchButton from "@/components/SwitchButton.vue";
import VDelete from "@/components/VDelete.vue";
import Decimal from "decimal.js";
import SelectOption from "@/common/ui/presenters/select-option";
import TaskType from "@/entities/task-type";
import TaskTypeNewModal from "@/views/TaskTypeNewModal.vue";

@Component({
  components: {
    VDelete,
    SwitchButton,
    TaskTypeNewModal
  }
})
export default class CompanyEdit extends Vue {
  @Prop({ required: true }) company!: Company;
  @Prop({ required: true }) office!: Office;
  @Prop({ type: Boolean, default: false }) removable!: boolean;
  @Prop({ default: () => [] }) tasktypes!: TaskType[];

  companyTypeOptions = [
    { text: "法人", value: CompanyType.Corporation },
    { text: "個人", value: CompanyType.Individual },
    { text: "エンドユーザー", value: CompanyType.EndUser }
  ];

  days = _.range(1, 32).map(day => ({
    value: day,
    text: day.toString()
  }));
  dayOptions = [{ value: "", text: "" }, ...this.days];
  get monthOption() {
    return _.range(1, 13).map(item => {
      return {
        value: item,
        text: `${item}月`
      };
    });
  }

  selectedBank = -1;

  protected created() {
    if (
      this.family &&
      this.office.bankAccounts &&
      this.office.bankAccounts.length !== 0
    ) {
      this.selectedBank = this.office.bankAccounts.findIndex(
        item => item.is_default === 1
      );
    }
  }

  get family() {
    return this.company.family;
  }

  defaultProfitRate = String(
    new Decimal(this.office.profitRate ? this.office.profitRate : 0).mul(100)
  );

  get profitRate(): string {
    if (this.office.profitRate === null) {
      return "";
    }
    return String(new Decimal(this.office.profitRate).mul(100));
  }

  set profitRate(profitRate: string) {
    if (!profitRate) {
      this.office.profitRate = null;
      return;
    }
    this.office.profitRate = new Decimal(profitRate).div(100).toNumber();
  }

  checkClient(checkBoxStatus: any) {
    if (checkBoxStatus) {
      this.office.profitRate = 0;
    } else {
      const defaultProfitRate = new Decimal(this.defaultProfitRate)
        .div(100)
        .toNumber();
      this.office.profitRate = defaultProfitRate ? defaultProfitRate : 0.2;
    }
  }

  status = "";

  submit() {
    if (
      this.family &&
      this.office.bankAccounts.length !== 0 &&
      this.selectedBank === -1
    ) {
      alert("振込先のデフォルトは必ず指定してください。");
      return;
    }

    this.office.bankAccounts.forEach((item, index) => {
      item.is_default = this.selectedBank === index ? 1 : 0;
    });

    this.status = "progressing";
    this.$emit("ok");
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }

  addBankAccount() {
    if (this.office.bankAccounts.length === 0) {
      this.selectedBank = 0;
    }

    this.office.bankAccounts.push({
      bank: "",
      branch: "",
      account: "",
      account_type: "",
      account_number: "",
      is_default: 0
    });
  }

  get workOptions(): SelectOption[] {
    return this.tasktypes.map(t => ({
      text: t.name,
      value: String(t.id)
    }));
  }
}
